export const CHOICE_VIEWS_STORAGE_KEY = 'choice.gig.views';
export const CHOICE_GIGS_STORAGE_LIMIT = 48;
export const CHOICE_VIEWS_STORAGE_TTL = 8640000000; // 100 days
